
function Footer(){
    return(
        <div className="footer">
            <h3 className="footer-txt">Made by <a href="https://twitter.com/yuricodesbot"> Yuri</a> <br />
            Have an idea you want to <a href="https://github.com/YuriCodes/article-ideas-api" target="_blank"> submit? </a></h3>
            
        </div>

    )
}

export default Footer;